import { render, staticRenderFns } from "./RedFlag.vue?vue&type=template&id=0773f354&scoped=true"
import script from "./RedFlag.vue?vue&type=script&lang=js"
export * from "./RedFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0773f354",
  null
  
)

export default component.exports